import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs, Text } from "@mantine/core";
export default function Dashboard() {
    return _jsxs("div", { children: [_jsx(Breadcrumbs, { children: [
                    _jsx(Text, { size: "sm", c: "dimmed", children: "Home" }, 0),
                ] }), _jsx("h1", { children: "Dashboard" })] });
}
